import classNames from "classnames";
import React, { useContext } from "react";
import { FormContext } from "../../App";
import ErrorMessage from "../ErrorMessage/ErrorMessage";
import Label from "../Label/Label";
import style from "./Checkbox.module.css";

interface InputProps {
  label: React.ReactNode;
  name: string;
  required?: boolean;
}
const Checkbox = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, name, required }, ref) => {
    const { register, errors } = useContext(FormContext);
    return (
      <div className={style.inputContainer}>
        <label className={style.checkboxContainer}>
          <input
            type="checkbox"
            ref={ref}
            {...register(name, {
              required: required && "Required field",
            })}
            className={classNames(style.inputElement, {
              [style.error]: errors[name],
            })}
          ></input>
          <span className={style.checkmark}></span>
          <Label text={label} required={required} />
        </label>
        <ErrorMessage name={name} />
      </div>
    );
  }
);
export default Checkbox;
